import React, { useContext, useState, useRef } from "react";
import { useHistory } from "react-router-dom";

import ComponentContainer from "./utils/ComponentContainer";
import AuthContext from "./Context/AuthContext";
import avatarIco from "../assets/img/avatar.jpg";
import Field from "./forms/Field";

import { icon64b } from "../components/utils/icons";

const Profile = () => {
  const {
    userProfile,
    handleUpdateProfile,
    logoutUser,
    handleProfileFields,
    setUserProfile,
    managePasswordForm,
    submitPassword,
  } = useContext(AuthContext);
  const history = useHistory();
  const passwordForm = useRef(null);
  const [passwordsMsg, setPasswordMsg] = useState([]);
  const [passwordsLoading, setPasswordLoading] = useState(false);

  const handleDisconnect = () => {
    logoutUser(history);
  };

  const handleSubmit = (e) => {
    handleUpdateProfile(e);
  };

  const displayAvatar = () => {
    let imgUrl = userProfile.avatarPreview || `${process.env.REACT_APP_URL_SERVER}${userProfile.avatar}`;

    if (userProfile.avatarPreview === "" && userProfile.avatar === "") return;

    return <img src={imgUrl} alt="avatar" onError={handleError} style={{ width: "40px", height: "40px" }} />;
  };

  function handleError() {
    const img = icon64b;
    setUserProfile((state) => {
      return { ...state, avatarPreview: img };
    });
  }

  const handleSubmitPassword = (e) => {
    e.preventDefault();
    setPasswordLoading(true);
    submitPassword().then((msgs) => {
      if(msgs[0].code === 200) {
        managePasswordForm("reset");
        passwordForm.current.reset();
        setTimeout(() => {
          setPasswordMsg([]);
        }, 3500);
      }
      setPasswordMsg(msgs);
      setPasswordLoading(false);
    });
  };

  return (
    <ComponentContainer>
      <h1>Profile</h1>
      <div className="profile">
        <section className="profile__disconnect">
          <button onClick={() => handleDisconnect()}>Logout</button>
        </section>

        <section className="profile__header">
          <img src={avatarIco} alt="avatar" />
          <p>
            Welcome <span className="bold">{userProfile.email} </span>. <span className="bold">You can edit</span> your
            profile here !
          </p>
        </section>

        <div className="profile__forms">
          <form className="profile__forms__form" onSubmit={handleSubmit}>
            <div className="profile__forms__form__fields">
              <fieldset className="profile__forms__form__field">
                <legend>Profile informations</legend>
                {displayAvatar()}
                <label htmlFor="avatar">Avatar</label>
                <input
                  id="avatar"
                  name="avatar"
                  type="file"
                  accept="image/png, image/jpeg, image/svg+xml"
                  onChange={(e) => {
                    handleProfileFields(e, true);
                  }}
                />
                <Field name="email" title="email" placeholder="Your email" value={userProfile.email} disabled={true} />
              </fieldset>
              <fieldset className="profile__forms__form__field">
                <legend>Delivery informations</legend>
                <Field
                  name="street"
                  title="street"
                  placeholder="Your street"
                  value={userProfile.street}
                  handleForm={handleProfileFields}
                />
                <Field
                  name="city"
                  title="city"
                  placeholder="Your city"
                  value={userProfile.city}
                  handleForm={handleProfileFields}
                />
                <Field
                  name="phone"
                  title="phone"
                  placeholder="Your phone"
                  type="number"
                  value={userProfile.phone}
                  handleForm={handleProfileFields}
                />
              </fieldset>
            </div>
            <button id="save" className="btn btn-primary btn-sm">
              Save
            </button>
          </form>

          <form onSubmit={(e) => handleSubmitPassword(e)}
          ref={passwordForm}
          className="profile__forms__form">
            <div className="profile__forms__form__fields">
              <fieldset className="profile__forms__form__field">
                <legend>Credentials informations</legend>
                <Field
                  name="password"
                  title="Actual password"
                  placeholder="Your password"
                  type="password"
                  handleForm={managePasswordForm}
                />
                <Field
                  name="npassword"
                  title="New password"
                  placeholder="Your new password"
                  type="password"
                  handleForm={managePasswordForm}
                />
                <Field
                  name="vnpassword"
                  title="New password Confirmation"
                  placeholder="Confirm your new password"
                  type="password"
                  handleForm={managePasswordForm}
                />

                {passwordsMsg.length > 0 &&
                  passwordsMsg.map((msg, i) => (
                    <p key={i} data-code={msg.code} className="msg__server">
                      {msg.msg}
                    </p>
                  ))}
              </fieldset>
            </div>

            <button 
            onClick={(e) => handleSubmitPassword(e)} 
            id="save" 
            className="btn btn-primary btn-sm"
            disabled={passwordsLoading}
            >
              Save
            </button>
          </form>
        </div>
      </div>
    </ComponentContainer>
  );
};

export default Profile;
